import createIconComponent from './utils/createIconComponent';
import React from 'react';
const StopSolid = createIconComponent({
  height: 24,
  width: 24,
  content: (
    <path
      d='M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333
            22H3.667A1.67 1.67 0 0 1 2 20.333z'></path>
  ),
});
StopSolid.displayName = 'StopSolid';
export default StopSolid;
